function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Rewards = function Rewards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M12 22.94H3.5c-.41 0-.75-.34-.75-.75v-15c0-.41.34-.75.75-.75h3.486c-.522-.662-.662-1.304-.656-1.81 0-.92.37-1.78.96-2.31 1.16-1.05 2.96-1.06 4.17-.02q.227.201.435.441c.245-.342.498-.619.765-.851 1.31-1.13 3.26-1.12 4.52.02.64.58 1.03 1.52 1.04 2.51 0 .562-.156 1.28-.76 2.02h3.04c.41 0 .75.34.75.75v15c0 .41-.34.75-.75.75zm-.75-18.56a.7.7 0 0 1-.14-.17q-.285-.48-.63-.78c-.63-.54-1.59-.54-2.18 0-.28.25-.46.73-.46 1.22 0 .78.798 1.398 1.496 1.79h1.914zm8.5 17.06h-7.02V7.94h2.51a1 1 0 0 0 .154 0h4.356zm-4.625-15H12.73V4.16c.03-.04.09-.13.09-.13l.09-.13c.22-.36.46-.66.72-.88.73-.62 1.85-.62 2.54 0 .33.3.54.84.54 1.42.01.864-.818 1.547-1.585 2m-3.875 1.5v13.5h-7V7.94z",
    clipRule: "evenodd"
  }));
};
export default Rewards;
Rewards.displayName = 'Rewards';